import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  employees: [],
  employeesByDepartment: [],
  employee: {},
  employeeSkills: [],
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
  addEmployeeSkill: false,
  activeEmployee: [],
  pagination: {},
  employeeSkill: {},
  empWithoutSalary: [],
  activeEmp: [],
};
const getters = {
  employeesListGet: (state) => state.employees,
  employeesByDepartmentListGet: (state) => state.employeesByDepartment,
  employeeByIdGet: (state) => state.employee,
  employeeSkillsGet: (state) =>
    state.employeeSkills.map((item) => ({
      skillId: item.id,
      skillName: item.skill,
      skillValue: parseInt(item.skill_level),
    })),
  paginationGetEmp: (state) => state.pagination,
  activeEmployeeGet: (state) => state.activeEmployee,
  employeeSkillId: (state) => state.employeeSkill,
  getEmpWithoutSalary: (state) => state.empWithoutSalary,
  getActiveEmployees: (state) => state.activeEmp,
};
const actions = {
  getEmployees({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    const params = new URLSearchParams();

    const addToParams = (key, value) => {
      if (value) {
        params.append(key, value);
      }
    };

    addToParams("directorate_id", payload.directorateId);
    addToParams("department_id", payload.departmentId);
    addToParams("date", payload.date);
    addToParams("type", payload.type);

    const url = `employees?${params.toString()}&page=${page}`;

    console.log(url, "employee url  ");
    service.getFun(url).then(
      (obj) => {
        console.log("response is", obj);
        payload = obj?.data?.employees;
        const pageResult = {
          currentPage: obj?.data?.current_page,
          lastPage: obj?.data?.last_page,
          itemsPerPage: obj?.data?.per_page,
          total: obj?.data?.total,
        };
        commit("employeesListSet", payload);
        commit("setPagination", pageResult);
      },
      (error) => {
        console.log("employees..." + error);
        toastError(error);
      }
    );
  },
  getActiveEmployees({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`active_employee?page=${page}`).then(
      (obj) => {
        payload = obj.data;
        const pageResult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("employeesActiveListSet", payload);
        commit("setPagination", pageResult);
      },
      (error) => {
        console.log("employees..." + error);
        toastError(error);
      }
    );
  },
  async getAllEmpWithoutSalary({ commit }, payload) {
    const result = await service.getFun(
      `employee-list?year=${payload?.year}&month=${payload?.month}`
    );
    if (result) {
      commit("setEmpListWithoutSalary", result.data);
    }
  },
  async getAllActiveEmp({ commit }) {
    const result = await service.getFun(
      `employee_vacations/active_employees_list`
    );
    if (result) {
      commit("setActiveEmp", result.data);
    }
  },
  getEmployeesByDepartmentId({ commit }, payload) {
    service
      .getFun(
        `departments-employee/${payload.department_id}?page=${store.state.page.page}`
      )
      .then(
        (obj) => {
          payload = obj.data;
          commit("employeesByDepartmentListSet", payload);
        },
        (error) => {
          console.log("employees..." + error);
          toastError(error);
        }
      );
  },
  getEmployeeSkills({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`get-employee-skills/${payload.id}?page=${page}`).then(
      (obj) => {
        console.log(obj.data, " employee skills");
        payload = obj.data;
        commit("getEmployeeSkills", payload);
      },
      (error) => {
        console.log("employees..." + error);
        toastError(error);
      }
    );
  },
  addEmployeeSkill({ commit }, payload) {
    const data = service.deleteNullValues(payload);
    service
      .postFun(data, `employee-skills/store`, null, {
        action: "getEmployees",
      })
      .then(
        (result) => {
          if (result) {
            commit("addEmployeeSkillStatus", result.success);
            toast("All Good");
          } else {
            commit("addEmployeeSkillStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  getEmployeeSkillById({ commit }, payload) {
    service.getFun(`get-employee-skills/${payload}`).then(
      (obj) => {
        payload = obj.data;
        commit("getEmployeeSkillId", payload);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editEmployeeSkill({ commit }, payload) {
    const data = service.deleteNullValues(payload);
    service
      .postFun(data, `employee-skills/edit/${payload.id}`, null, {
        action: "getEmployees",
      })
      .then(
        (result) => {
          if (result) {
            commit("EditEmployeeSkill", result.success);
            toast("All Good");
          } else {
            commit("EditEmployeeSkill", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  addEmployee({ commit }, payload) {
    const data = service.convertToFormData(service.deleteNullValues(payload));
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    service
      .postFun(data, `employee/store`, options, {
        action: "getEmployees",
      })
      .then(
        (result) => {
          if (result) {
            commit("addEmployeeStatus", result.success);
            toast("All Good");
          } else {
            commit("addEmployeeStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  getEmployeeById({ commit }, payload) {
    service.getFun(`employee/${payload}`).then(
      (obj) => {
        let result = obj.data;
        commit("employeeByIdSet", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editEmployee({ commit }, payload) {
    const data = service.convertToFormData(service.deleteNullValues(payload));
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    service
      .postFun(data, `employee/edit/${payload.id}`, options, {
        action: "getEmployees",
      })
      .then(
        (result) => {
          if (result) {
            commit("editEmployeeStatus", result.success);
            toast("All Good");
          } else {
            commit("editEmployeeStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteEmployee({ commit }, payload) {
    service
      .postFun(null, `employee/delete/${payload.payload}`, null, {
        action: "getEmployees",
      })
      .then(
        (result) => {
          if (result) {
            commit("editEmployeeStatus", result.success);
            toast("All Good");
          } else {
            commit("editEmployeeStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  employeesListSet(state, employees) {
    state.employees = employees;
  },
  employeesActiveListSet(state, employees) {
    state.activeEmployee = employees;
  },
  employeesByDepartmentListSet(state, employeesByDepartment) {
    state.employeesByDepartment = employeesByDepartment;
  },
  addEmployeeStatus(state, status) {
    state.addStatus = status;
  },
  editEmployeeStatus(state, status) {
    state.editStatus = status;
  },
  employeeByIdSet(state, employee) {
    state.employee = employee;
  },
  getEmployeeSkills(state, employeeSkills) {
    state.employeeSkills = employeeSkills;
  },
  addEmployeeSkillStatus(state, status) {
    state.addEmployeeSkill = status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
  getEmployeeSkillId(state, payload) {
    state.employeeSkill = payload;
  },
  EditEmployeeSkill(state, status) {
    state.editStatus = status;
  },
  setEmpListWithoutSalary(state, payload) {
    state.empWithoutSalary = payload;
  },
  setActiveEmp(state, payload) {
    state.activeEmp = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
